import React from "react";
import { getStyle } from "../../../styles/styles";
import GenericBoard from "../../shared/GenericBoard";
import { BoardName } from "../../../constants/BoardNames";

var style = getStyle()

export default class BNOrdersBoardScreen extends React.Component {    
    state = {
        showTitle: true
    }

    componentDidMount() {}
    
    isShowTitle = (value) => {
        this.setState({ showTitle: value })
    }

    render(){
        return(
            <div>
                {this.state.showTitle && <h3 className="uk-heading-divider" style={style.titleStyle}>BNOrders Boards</h3>}
                <GenericBoard board={BoardName.BNOrderBoard} mainTitle={"BNOrders Boards"} isShowTitle={this.isShowTitle} selectSection refreshOnBack={true}/>
            </div>
        )
    }
}
